import {injectable} from "tsyringe";
import {CreateIssueStatusCommand} from "../commands/create-issue-status.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {TransformerHelper} from "../helpers/transformer.helper";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: CreateIssueStatusCommand,
    target: `dto`
})
export class CreateIssueStatusCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueStatus> {

    protected async toDTO(issueStatus: IssueStatus): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(issueStatus);
    }
}
